module.exports = function getResource(label, vars = []) {
    const resources = {
        installmentsWithAfterpayAndKlarna: `ou quatre paiements de ${vars[0]} avec`,
        or: 'ou ',
        testCardDiscount: `or ${vars[0]} off your Sephora order when you open and use a Sephora Credit Card today.¹`,
        test: 'Earn 2x Beauty Insider Points with every $1 spent using your Sephora Credit Card at Sephora',
        testSeeDetails: 'Voir les détails',
        learnMore: 'En savoir plus',
        rewardMessaging: 'Earn $5 in rewards for every $125 you spend using your Sephora Credit Card at Sephora.²',
        pointsEligible: 'Earn 2x Beauty Insider Points with every $1 spent using your Sephora Credit Card at Sephora'
    };

    return resources[label];
};
